import { MONTHS_SHORT } from '@bbl-digital/snorre/lib/utils/dates'
import { PayloadAction } from '@reduxjs/toolkit'
import axios, { AxiosResponse } from 'axios'
import { call, put, select, takeEvery } from 'redux-saga/effects'
import { IClient } from 'shared/models/Client'
import { ICommonListModel } from 'shared/models/Common'
import { getActiveClient } from 'shared/store/clients/selectors'
import {
  fetchApproverHandlerError,
  fetchApproverHandlerRequest,
  fetchApproverHandlerSuccess,
  fetchYearlyApprovalsError,
  fetchYearlyApprovalsRequest,
  fetchYearlyApprovalsSuccess,
  newOwnersError,
  newOwnersRequest,
  newOwnersSuccess,
} from '.'
import {
  getApproverHandler,
  getChangeOfOwnerships,
  getYearlyApprovals,
} from '../../api/change-of-ownership.api'
import {
  ApprovalHandler,
  IApprovalResponseModel,
  INewOwnerFilters,
} from '../../models/NewOwners'

function* fetchNewOwners({ payload }: PayloadAction<INewOwnerFilters, string>) {
  try {
    const client: IClient = yield select(getActiveClient)

    const body = {
      ...payload,
      clientId: client.id,
    }

    const response: AxiosResponse<ICommonListModel<IApprovalResponseModel>> =
      yield call(getChangeOfOwnerships, body)

    yield put(newOwnersSuccess(response.data))
  } catch (e) {
    if (!axios.isCancel(e)) {
      console.log(e)
      yield put(newOwnersError(e))
    }
  }
}

function* fetchApproverHandler() {
  try {
    const client: IClient = yield select(getActiveClient)
    const response: AxiosResponse<ApprovalHandler> = yield call(
      getApproverHandler,
      client.id
    )
    yield put(fetchApproverHandlerSuccess(response.data))
  } catch (e) {
    yield put(fetchApproverHandlerError(e))
  }
}

function* fetchYearlyApprovals({ payload }: PayloadAction<number>) {
  try {
    const client: IClient = yield select(getActiveClient)
    const response: AxiosResponse<number[]> = yield call(
      getYearlyApprovals,
      client.id,
      payload
    )

    const convertedToMonths = response.data.map((amount, index) => ({
      [MONTHS_SHORT[index]]: amount,
    }))

    yield put(fetchYearlyApprovalsSuccess(convertedToMonths))
  } catch (e) {
    yield put(fetchYearlyApprovalsError(e))
  }
}

function* newOwnersSaga() {
  yield takeEvery(newOwnersRequest.type, fetchNewOwners)
  yield takeEvery(fetchApproverHandlerRequest.type, fetchApproverHandler)
  yield takeEvery(fetchYearlyApprovalsRequest.type, fetchYearlyApprovals)
}

export default newOwnersSaga
